/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToEm, replacePXinStringWithEM, mediaQuery } from '@insticator/insticator-ui'; // iui-utils



// ********* HELPERS ********* //
const imageSelectorThinStyles = {
	'&.isActive': {
		'&-true': {
			'&.loaded': {
				flex: replacePXinStringWithEM(`0 0 164px`)
			}
		}
	},
	'& .controls': {
		paddingBottom: pxToEm(10),
		'& .innerControls': {
			'& .field.name-imagetype': {
				display: 'block'
			},
			'& .imageTypes': {
				display: 'none'
			}
		}
	},
	'& .imagecontainer': {
		'& .image': {
			'& .imagevisual': {
				height: pxToEm(68)
			}
		}
	},
	'& .pagebuttons': {
		'& .button': {
			'& .text': {
				display: 'none'
			}
		}
	}
};
const imageSelectorThinnerStyles = {
	'&.isActive': {
		'&-true': {
			'&.loaded': {
				flex: replacePXinStringWithEM(`0 0 100%`),
				width: '100%',
				height: '100%',
				position: 'absolute',
				top: '0',
				left: '0',
				opacity: '0',
				zIndex: '-1'
			},
			'&.activeImageSelect': {
				'&-true': {
					animationDuration: '.2s',
		        	animationFillMode: 'forwards',
					animationName: 'fadeInLeft',
					animationDelay: '.0s',
					zIndex: '1000'
				}
			}
		}
	},
	'& .imageapi': {
		margin: '0 auto',
		width: '90%',
		'& .imagepane': {
			'& .pane': {
				'& .innerPane': {
					justifyContent: 'center'
				}
			}
		}
	}
};



/* ++++++++++ --------------- EXPORT : EMBED IMAGE SELECTOR : STYLES --------------- ++++++++++ */
export default theme => ({
	imageselector: {
		background: theme.color.light.light.swatch,
		border: replacePXinStringWithEM(`1px solid #ECF0F7`),
		borderTop: '0',
		boxShadow: replacePXinStringWithEM(`0 1px 1px 0 #EDF1FA`),
		position: 'relative',
		overflow: 'hidden',
		flex: replacePXinStringWithEM(`0`),
		transition: 'all .2s ease-in-out 0s',
		'&:hover': {
			boxShadow: theme.boxShadow.highlightCard
		},
		'&.isActive': {
			'&-true': {
				'&.loaded': {
					flex: replacePXinStringWithEM(`0 0 302px`)
				}
			}
		}
	},

	// ((((((((((((((( MEDIA QUERIES ))))))))))))))) //
	[mediaQuery.customizeThinnest]: { 
		imageselector: {
			extend: imageSelectorThinnerStyles
		}
	},
	[mediaQuery.customizeRailThin]: { 
		imageselector: {
			'&.rail': { extend: imageSelectorThinStyles }
		}
	},
	[mediaQuery.customizeInContentThin]: { 
		imageselector: {
			'&.incontent': { extend: imageSelectorThinStyles }
		}
	}
});
